import { useCancellationStore } from '../stores/cancellations';
import { useGeneralStore } from '../stores/general';
import { useMerchantStore } from '../stores/merchants';
import { useOrderStore } from '../stores/orders';
import { useUserStore } from '../stores/users';

export const resetAllStores = () => {
  useCancellationStore().reset();
  useGeneralStore().reset();
  useMerchantStore().reset();
  useOrderStore().reset();
  useUserStore().reset();
};
